import { Inbox } from 'lucide-react'

interface EmptyStateProps {
  title: string
  description: string
  showIcon?: boolean
}

export default function EmptyState({ title, description, showIcon = true }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      {showIcon && (
        <Inbox className="w-12 h-12 text-gray-400 dark:text-gray-500 mb-4" />
      )}
      <h3 className="text-lg font-medium text-blue-950 dark:text-white mb-2">
        {title}
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 text-center max-w-md">
        {description}
      </p>
    </div>
  )
}
